// extracted by mini-css-extract-plugin
export default {"featureItem":"styles_featureItem__Jf-0O","label":"styles_label__bd5Fs"};